<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-toolbar dense>
          {{ $t("registerNewBonus") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('closeDialog')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            :lazy-validation="lazy"
            autocomplete="off"
          >
            <v-row>
              <v-col cols="12">
                <span class="pl-9">{{ $t("choosePlayerToApplyBonus") }}</span>
                <AutocompletePlayers :rules="[rules.required]"
              /></v-col>
              <v-col cols="6" class="px-2">
                <v-autocomplete
                  v-model="gameID"
                  :rules="[rules.required]"
                  :items="items"
                  item-text="nome_jogo"
                  item-value="id_game"
                  hide-selected
                  :label="$t('game')"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" class="px-2">
                <v-text-field
                  v-model="rounds"
                  label="Rounds"
                  dense
                  outlined
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- CALENDAR START -->
            <v-row class="my-0 py-0">
              <v-col cols="6" class="px-2">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="200"
                  class="my-0 py-0"
                  offset-y
                >
                  <template v-slot:activator="{ on }" class="my-0 py-0">
                    <v-text-field
                      v-model="computedDateFormattedStart"
                      outlined
                      :label="$t('dateFinal')"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      hint="DD/MM/YYYY"
                      class="mt-2"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateFinal"
                    @input="menuStart = false"
                    :min="dateGetTimezoneOffset"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="pr-2 pl-0">
                <v-text-field
                  v-model="timeFinal"
                  :rules="[rules.required]"
                  :label="$t('timeFinal')"
                  placeholder="hh:mm:ss"
                  dense
                  outlined
                  class="mt-2 ml-2"
                  v-mask="'##:##:##'"
                  :error="!hideDetailsFinal"
                  :error-messages="errorTimeFinal"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            @click="createBonus()"
            :disabled="!valid || loading"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";
import AutocompletePlayers from "@/components/common/filters/AutocompletePlayers";
import axios from "axios";

export default {
  props: ["dialog"],
  name: "backoffice-administrator-dialog-create-casino-bonus",
  components: {
    AutocompletePlayers,
  },
  data: () => ({
    //Validate Form
    valid: true,
    lazy: false,
    loading: false,

    //Request - Body
    menuStart: false,
    timeFinal: "",
    dateFinal: "",
    rounds: 1,
    gameID: "",
    // Autocomplete Agente
    selectAffiliate: null,
    isLoading: false,
    agents: [],
    search: null,
    term: "",
    // Selects Items
    items: [],
    itemsPercentage: [],
    // Errors
    errorTimeFinal: "",
    hideDetailsFinal: true,
    // hideDetailsDate: true,
    //Rules
    rules: {
      noSpacesAreAllowed: validate.noSpacesAreAllowed,
      required: validate.required,
      negativeNo: validate.negativeNo,
      max20: validate.max20,
    },
    // DEBUG DATE START
    // computedDateFormattedStart: "",
    // computedDateFormattedFinal: "",
  }),
  computed: {
    computedDateFormattedStart() {
      return this.formatDate(this.dateFinal);
    },
    computedDateFormattedFinal() {
      return this.formatDate(this.dateFinal);
    },
    dateGetTimezoneOffset() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
  },
  async mounted() {
    this.reset();
    // this.$request
    //   .get("/administrator/cassino/games/list")
    //   .then((response) => {
    //     this.items = [...response.dados.slice(1)];
    //     console.log(this.items);
    //   })
    //   .catch((error) => console.log(error));

    this.fetchGames();
  },
  watch: {
    timeFinal(val) {
      if (val.length == 8) {
        this.timeValidated(val, "final");
      } else {
        this.errorTimeFinal = "";
        this.hideDetailsFinal = true;
      }
    },
  },
  methods: {
    fetchGames() {
      if (this.$store.state.operator.casino == "0") {
        return;
      }

      const body = {
        domain: localStorage.getItem("operator"),
      };

      this.$axios
        .post(
          "/administrator/cassino/games/listByOperator",
          this.$formdata(body)
        )
        .then((res) => {
          this.items = res.data.dados.filter(
            (game) =>
              game.id_game != "0" &&
              game.id_game != "250" &&
              game.id_tipo != "lg"
          );

          this.items.forEach((item) => {
            let str = item.id_game_provedor;
            str = str.substring(str.indexOf("-") + 1);
            item.id_game = str;
          });
        });
    },
    createBonus() {
      this.loading = true;

      const body = this.$formdata({
        date_expiration: `${this.dateFinal} ${this.timeFinal}`,
        id_user: this.$store.state.filters.autocompletePlayers.id,
        rounds: this.rounds,
        id_game: this.gameID,
      });

      const endpoint =
        "https://gen.envrelease.com/administrator/bonus/setFreeRounds";

      const headers = {
        "Content-Type": "multipart/form-data",
        "Application-Authorization": this.$axios.defaults.headers.common[
          "Application-Authorization"
        ],
        ip: this.$axios.defaults.headers.ip,
      };

      axios({
        method: "post",
        url: endpoint,
        data: body,
        headers,
      })
        .then((res) => {
          this.reset();
          this.$emit("closeDialog");
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Get Lista de agentes
    async getAgentsList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(
          "/administrator/agents/search",
          {
            term: this.term,
          }
        );

        if (response.length == 0) {
          this.agents = [];
          return;
        }

        this.agents = response.dados.map((item) => ({
          ui: `${item.nome} (${item.login} ${item.id})`,
          name: item.nome,
          icon: item.online,
          login: item.login,
          id: item.id,
        }));
      } finally {
        this.isLoading = false;
      }
    },
    reset() {
      this.hideDetailsFinal = true;
      this.dateFinal = this.dateGetTimezoneOffset;
      this.timeFinal = "23:59:59";
      this.rounds = 1;
      this.gameID = "";
    },
    // Valida se as horas são validas
    timeValidated(time, moment) {
      if (time > "23:59:59") {
        if (moment == "start") {
          this.errorTimeFinal = this.$t("invalidTime");
          this.hideDetailsFinal = true;
          return;
        } else {
          this.errorTimeFinal = this.$t("invalidTime");
          this.hideDetailsFinal = true;
        }
      }
      this.errorTime = "";
      this.hideDetails = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
